<template>
    <div class="forgot-password">
        <HeaderCentered
            :title="$t('login.password_recovery.form.title')"
            :subtitle="$t('login.password_recovery.form.subtitle')"
            :logo="$whitelabel.resources.logo"
        />
        <OtCardContent>
            <OtInputField
                :label="$t('login.password_recovery.form.email')"
            >
                <OtInput
                    type="email"
                    :invalid="error"
                    :placeholder="$t('login.password_recovery.form.email')"
                    v-model="recoveryEmail"
                />
            </OtInputField>
            <div class="footer">
                    <OtButton
                        class="footer__cta ot-button is-fullwidth"
                        @click="sendRecoveryEmail"
                        :disabled="!recoveryEmail"
                        :title="$t('login.password_recovery.form.confirm.title')"
                    >
                        <i class="oti ot-button-icon--left oti-check"/>
                        {{ $t('login.password_recovery.form.confirm.text') }}
                    </OtButton>
              <OtButton
                  class="footer__back ot-button is-link is-small"
                  @click="$router.push({name: 'login', query: $route.query})"
                  :title="$t('login.signup.back.title')"
              >
                <i class="oti oti-arrow-left ot-button-icon--left is-small"/>
                {{ $t('login.signup.back.text') }}
              </OtButton>
            </div>
        </OtCardContent>
    </div>
</template>

<script lang="ts">
import urlJoin from 'url-join';
import { Component, Vue } from 'vue-property-decorator';
import Axios from 'axios';
import HeaderCentered from '../HeaderCentered.vue';
import OtButton from '../OtButton.vue';
import { rudderAnalyticsTrack } from '../../services/util/rudderstack';

@Component({ components: { HeaderCentered, OtButton } })
export default class PasswordRecoveryForm extends Vue {

    recoveryEmail: string | null = null;

    error = false;

    async sendRecoveryEmail(): Promise<void> {
        const http = Axios.create();
        try {
            const clientId: string | null = new URLSearchParams(window.location.search).get('client_id');
            if (!clientId) {
                window.location.href = this.$whitelabel.login.fallback_app_url;
                return;
            }

            // TODO - @openticket/lib-auth
            await http.post(
                urlJoin(this.$whitelabel.login.auth_api_url, 'passwords', 'forgot'),
                {
                    client_id: clientId,
                    email: this.recoveryEmail,
                },
            );
            rudderAnalyticsTrack('password recovery sent');
            this.$notifications.success(this.$t('login.password_recovery.success'));
        } catch (e) {
            this.error = true;
            rudderAnalyticsTrack('password recovery error');
            this.$notifications.warning(this.$t('auth.error.unexpected'));
            return;
        }

        this.$emit('submitted', this.recoveryEmail);
    }

}
</script>

<style lang="scss" scoped>
.no-background-color {
    background-color: transparent !important;
}
.footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: var(--ot-spacing-2xl);
    gap: var(--ot-spacing-default);
}
</style>
